import { Loader2 } from "lucide-react";
import * as React from "react";

import { componentLoaderTestIds } from "@/lib/data-test-ids";
import { cn } from "@/lib/utils";

export function Loader({
  className,
  ...props
}: React.ComponentProps<typeof Loader2>) {
  return (
    <Loader2
      className={cn("animate-spin", className)}
      data-testid={componentLoaderTestIds.ELEMENT}
      {...props}
    />
  );
}

export function CenteredLoader({ className }: { className?: string }) {
  return (
    <div className={cn("flex justify-center", className)}>
      <Loader />
    </div>
  );
}
